import { render } from "./UpdateIssueStatus.vue?vue&type=template&id=6bcbb214"
import script from "./UpdateIssueStatus.vue?vue&type=script&lang=js"
export * from "./UpdateIssueStatus.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_13b2cfeee597e475bd48dd409a32edc8/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__